<template>
  <div class="nav">

    <div class="hidden-sm-down">
      <div class="deco">
        <img src="../../assets/topBar_deco.png" />
      </div>

      <div class="logo" v-on:click="activeTab = null">
        <router-link to="/" >
          <img src="../../assets/logo.png" />
        </router-link>
      </div>
    </div>

    <div class="hidden-md-up">
      <div class="deco"
          v-bind:class="{ hide: mMenuToggle }"
      >
        <img src="../../assets/topBar_deco.png" />
      </div>

      <div class="m_logo"
            v-bind:class="{ hide: mMenuToggle }"
            v-on:click="activeTab = null"
      >
      <router-link to="/">
        <img src="../../assets/logo.png" />
      </router-link>
      </div>
    </div>
    
    <div class="menu">
      <ul class="topLayer hidden-sm-down" >
        <li class="topLayer_li" 
            v-for="(tab, index) in menuTab" 
            :class="{active: activeTab === tab.path}"
        >
          
          <div class="link" v-if="tab.subTab">
            {{tab.name}}
            <div class="subLayer-container">
              <ul class="subLayer">
                <li v-for="subTab in tab.subTab">
                  <router-link :to="subTab.route"
                              v-on:click.native="clickTab(tab.path)"
                  >
                    <img :src="subTab.img" :srcset="subTab.srcset+' 2x'" style="height:117px;"/>
                    <div class="tabButton">
                      <div class="aim">
                        <img src="../../assets/aimIcon.png"/>
                      </div>
                      <div class="name">
                        {{subTab.name}}
                      </div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <div class="link" v-else-if="tab.subTabDir">
            {{tab.name}}
            <div class="subLayer-container">
              <ul class="subLayer">
                <li v-for="subTabDir in tab.subTabDir">

                  <router-link :to="subTabDir.route"
                              v-on:click.native="clickTab(tab.path)"
                  >
                    <div class="tabButton">
                      <div class="aim">
                        <img src="../../assets/aimIcon.png"/>
                      </div>
                      <div class="name">
                        {{subTabDir.name}}
                      </div>
                    </div>
                  </router-link>

                </li>
              </ul>
            </div>
          </div>

          <router-link v-else :to="tab.route" 
                       class="link"
                       v-on:click.native="clickTab(tab.path)"
          >
            {{tab.name}}
          </router-link>

        </li>
      </ul>

      <div class="mMenuBtn hidden-md-up" 
           v-bind:class="{ open: mMenuToggle }"
           v-on:click="openMobileMenu"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

    </div>

     <div class="mMenu" 
          v-bind:class="{ open: mMenuToggle }"
      >
      
      <div class="mMenuBtn hidden-md-up open"
           v-on:click="openMobileMenu"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <ul class="topLayer">
        <li class="topLayer_li" 
            v-for="(tab, index) in menuTab" 
            :class="{active: activeTab === tab.path, product: tab.subTab}"
        >

          <div class="link subTabLink" v-if="tab.subTab">
            {{tab.name}}
            <ul class="subLayer">
              <li v-for="subTab in tab.subTab">
                <router-link :to="subTab.route"
                             v-on:click.native="clickTab(tab.path)"
                >
                  <div class="mSubTabImgWrapper">
                    <img :src="subTab.img" :srcset="subTab.srcset+' 2x'"/>
                  </div>
                  <div class="tabButton">
                    <div class="">
                      <div class="aim">
                        <img src="../../assets/aimIcon.png"/>
                      </div>
                      <div class="name">
                        {{subTab.name}}
                      </div>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>

          <div class="link subTabLink" v-else-if="tab.subTabDir">
            {{tab.name}}
            <ul class="subLayer oneline">
              <li v-for="subTabDir in tab.subTabDir">
                <router-link :to="subTabDir.route"
                             v-on:click.native="clickTab(tab.path)"
                >
                  <div class="tabButton">
                    <div class="">
                      <div class="aim">
                        <img src="../../assets/aimIcon.png"/>
                      </div>
                      <div class="name">
                        {{subTabDir.name}}
                      </div>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>

          <router-link v-else :to="tab.route"
                       class="link"
                       v-on:click.native="clickTab(tab.path)"
          >
            {{tab.name}}
          </router-link>

        </li>
      </ul>
    </div> 

  </div>
</template>

<script>
export default {
  watch: {
    '$route': function (to, from) {
      this.activeTab = '/' + to.path.split('/')[1]
      this.closeMobileMenu()
    }
  },
  mounted () {
    const route = this.$route.matched[0].path
    this.activeTab = '/' + route.split('/')[1]
  },
  data () {
    return {
      mMenuToggle: false,
      activeTab: null,
      menuTab: [
        {
          name: '關於威滅',
          route: '/about',
          path: '/about'
        },
        {
          name: '產品',
          path: '/product',
          subTab: [
            {
              name: '曱甴',
              img: require('../../assets/menu-product_cockroach@2x.png'),
              srcset: require('../../assets/menu-product_cockroach@2x.png'),
              route: '/product/cockroach'
            },
            {
              name: '螞蟻',
              img: require('../../assets/menu-product_ant@2x.png'),
              srcset: require('../../assets/menu-product_ant@2x.png'),
              route: '/product/ant'
            }
          ]
        },
        {
          name: '防治方案與貼士',
          path: '/preventiontips',
          subTab: [
            {
              name: '預防小貼士',
              img: require('../../assets/menu-ptips@2x.png'),
              srcset: require('../../assets/menu-ptips@2x.png'),
              route: '/preventiontips/tips'
            },
            {
              name: '殺蟲藥指引',
              img: require('../../assets/menu-insecticideguide@2x.png'),
              srcset: require('../../assets/menu-insecticideguide@2x.png'),
              route: '/preventiontips/insecticideguide'
            },
            {
              name: '寵物家居安全',
              img: require('../../assets/menu-petsafety@2x.png'),
              srcset: require('../../assets/menu-petsafety@2x.png'),
              route: '/preventiontips/petsafety'
            },
            {
              name: '常見問題',
              img: require('../../assets/menu-faq@2x.png'),
              srcset: require('../../assets/menu-faq@2x.png'),
              route: '/preventiontips/faq'
            }
          ]
        },
        {
          name: '害蟲種類及資訊',
          path: '/pestidentification',
          subTab: [
            {
              name: '曱甴小常識',
              img: require('../../assets/menu-pest_cockroach@2x.png'),
              srcset: require('../../assets/menu-pest_cockroach@2x.png'),
              route: '/pestidentification/cockroach'
            },
            {
              name: '螞蟻小常識',
              img: require('../../assets/menu-pest_ant@2x.png'),
              srcset: require('../../assets/menu-pest_ant@2x.png'),
              route: '/pestidentification/ant'
            }
          ]
        },
        {
          name: '銷售地點',
          route: '/shoplist',
          path: '/shoplist'
        }
      ]
    }
  },
  methods: {
    openMobileMenu: function () {
      this.mMenuToggle = !this.mMenuToggle
      this.fixHtmlScroll()
    },
    closeMobileMenu: function () {
      if (this.mMenuToggle) {
        this.mMenuToggle = false
        this.fixHtmlScroll()
      }
    },
    clickTab: function (tab) {
      this.activeTab = tab
      this.closeMobileMenu()
    },
    fixHtmlScroll: function () {
      let html = document.getElementsByTagName('html')[0]
      if (this.mMenuToggle) {
        html.style.overflowY = 'hidden'
      } else {
        html.style.overflowY = 'auto'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../../styles/_vars.sass"
@import "../../styles/_hamburger.sass"

.nav
  position: fixed
  z-index: 9
  top: 0
  width: 100%
  background-color: $theme-yellow
  box-shadow: 5px 5px 25px rgba(0,0,0,.3)

  .deco
    position: absolute
    left: 0
    top: 0
    z-index: 0
    pointer-events: none

    @media only screen and (max-width: 768px)
      img
        width: 250px

  .logo
    position: absolute
    width: 135px
    left: 29px
    top: 21px
    z-index: 1000

    @media only screen and (max-width: 959px)
      width: 110px
      top: 18px

  .deco,
  .m_logo
    &.hide
      opacity: 0

  .m_logo
    position: absolute
    width: 100%
    text-align: center

    img
      position: relative
      width: 85px
      padding-top: 5px

  .menu
    height: $topMenu-height
    width: 100%
    text-align: center

    @media only screen and (max-width: 959px)
      text-align: right

    .mMenuBtn
      @extend .hamburger
      position: relative
      float: right 
      width: 20px
      height: 25px
      margin-top: 22px
      margin-right: 20px

    ul
      position: absolute
      margin-left: 35%
      padding-top: 11px
      z-index: 999
      position: relative
      margin-left: 0
      display: inline-block
      
      .topLayer_li
        font-size: 16px
        display: inline-block
        color: $font-grey
        position: relative
        cursor: pointer

        .link
          color: $font-grey
          text-decoration: none
          padding-left: 26px
          padding-right: 26px
          padding-top: 13px
          padding-bottom: 13px
          display: block

          @media only screen and (max-width: 959.98px)
            padding-left: 16px
            padding-right: 16px
        
        &:not(:last-child):after
          background-color: #c89a0e
          content: ""
          height: 20px
          position: absolute
          right: -2px
          top: 12px
          width: 2px
        
        &.active
          &:before
            content: ""
            position: absolute
            width: 100%
            height: 4px
            background-color: #e32219
            bottom: 0
            left: 0

        &:hover
          background-color: black
          .link
            color: $theme-yellow

          .subLayer
            visibility: visible
            opacity: 1
            pointer-events: auto
            box-shadow: 0 5px 25px rgba(250,193,18,.5)
          
        .subLayer-container
          position: absolute
          left: 50%

        ul.subLayer
          position: absolute
          margin-top: 13px
          left: 0
          visibility: visible
          white-space: nowrap
          margin-left: 0
          visibility: hidden
          padding-top: 0
          pointer-events: none
          opacity: 0
          z-index: 9999
          background-color: black
          position: fixed
          right: 0

          @media only screen and (max-width: 959px)
            text-align: center

          li
            display: inline-block
            padding: 17px
            min-width: 166px
            position: relative
            cursor: pointer
            vertical-align: middle

            &:not(:last-child):after
              content: ""
              position: absolute
              right: 0
              height: 80%
              top: 10%
              width: 2px
              background-color: #333333

            a 
              display: block

              img
                width: auto
                margin-bottom: 8px

            .tabButton
              background-color: $theme-yellow
              color: black
              padding: 7px 18px
              width: 100%
              border-radius: 15px
              text-align: center
              position: relative
              overflow: auto
              font-size: 0
              overflow: hidden

              .aim
                width: 20px
                height: 20px
                margin-right: 2px
                display: inline-block
                vertical-align: middle

                img
                  width: 100%

              .name
                padding-top: 1px
                display: inline-block
                vertical-align: middle
                font-size: 16px


  .mMenu
    position: fixed
    width: 100%
    background-color: $theme-yellow
    height: 100vh
    text-align: center
    font-size: 20px
    color: $font-grey
    opacity: 0
    pointer-events: none
    width: 100%
    left: 0
    display: table
    display: flex
    align-items: center
    overflow: scroll

    .mMenuBtn
      @extend .hamburger
      position: absolute
      width: 20px
      height: 25px
      margin-top: 22px
      right: 20px
      top: 0

    @media only screen and (min-width: 768px)
      display: none

    &.open
      pointer-events: auto
      opacity: 1

    ul.topLayer
      width: 100%
      margin: auto
      display: table-cell
      vertical-align: middle
      font-size: 16px
      padding-top: 28px
      padding-bottom: 28px

      li.topLayer_li
        position: relative

        .subTabLink
          padding-top: 15px
          padding-bottom: 15px
          padding: 10px 0 5px 0

        a 
          display: block
          padding-top: 15px
          padding-bottom: 15px
          padding: 10px 0

          &:hover
            color: $font-grey
        
        &:not(:last-child):after
          content: ''
          position: absolute
          bottom: 0
          height: 1px
          left: 20%
          width: 60%
          background-color: #c89a0e

        &.product:after
          height: unset
          left: unset
          width: unset
          background-color: transparent

        ul.subLayer
          margin-top: 13px
          width: 100%
          left: 0
          /* white-space: nowrap */
          opacity: 1
          background-color: black

          &.oneline
            display: inline-block
            padding: 8px 0

            li
              width: 100%
              float: left
              padding: 0

              &:not(:last-child):after
                content: ""
                position: absolute
                right: 0
                height: auto
                top: unset
                width: unset
                background-color: transparent

              a
                padding: 8px

                .tabButton

                  > div
                    width: auto
                    text-align: center

                  .aim
                    display: inline-block
                    vertical-align: middle
                    float: none
                    margin: 0

                  .name
                    display: inline-block
                    vertical-align: middle
                    float: none


          li
            display: inline-block
            padding: 0 17px
            width: 50%
            width: 100%
            position: relative
            cursor: pointer
            text-align: center

            &:not(:last-child):after
              content: ""
              position: absolute
              right: 0
              height: 80%
              top: 10%
              width: 2px
              background-color: #333333

            &:last-child
              a
                padding-bottom: 12px

            a 
              display: block
              padding: 12px 0 0 0

            .tabButton
              background-color: white
              color: black
              padding: 7px
              width: 90%
              border-radius: 0
              text-align: center
              position: relative
              overflow: hidden
              margin: auto

              & > div
                position: relative
                overflow: hidden
                width: auto
                margin: auto

                .aim
                  width: 20px
                  height: 20px
                  float: left
                  margin-top: -1px

                  img
                    width: 100%

                .name
                  padding-left: 5px
                  padding-top: 1px
                  float: left

            .mSubTabImgWrapper
              width: 100%
              position: relative
              display: none

              img
                max-width: 132px
                max-height: 87px
                display: inline-block
                float: none
                padding: 0 !important
                margin-bottom: 8px

</style>



// WEBPACK FOOTER //
// TopMenu.vue?5046a426